// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PermissionDetails__panel___2PinA{padding:0 24px}.PermissionDetails__staticMessage___1SOXD{padding-bottom:24px}.PermissionDetails__viewProperties___3kXgH{background:none;border:none;color:var(--spectrum-global-color-blue-400);cursor:pointer;padding:0}.PermissionDetails__toast___l9G4R{background-color:var(--spectrum-global-color-static-gray-800)!important;max-width:80%!important}.PermissionDetails__toast___l9G4R .spectrum-Button--overBackground{border:2px solid var(--spectrum-global-color-static-gray-600)!important}", ""]);
// Exports
exports.locals = {
	"panel": "PermissionDetails__panel___2PinA",
	"staticMessage": "PermissionDetails__staticMessage___1SOXD",
	"viewProperties": "PermissionDetails__viewProperties___3kXgH",
	"toast": "PermissionDetails__toast___l9G4R"
};
module.exports = exports;
